export default __webpack_public_path__ + "static/media/j_wdt_c_6.95471965.mp3";